module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class=\'ui-menu-item phx-populations-menu-select-structure phx-menu-link phx-hover ui-corner-all\'>\r\n  <a class="structureSelectorMenu" data-codeStructure="'+
((__t=( element.code ))==null?'':__t)+
'" href="#">\r\n    '+
((__t=(i18n.t("messages:GT_2128",{"1":element.libselpop})))==null?'':__t)+
'...\r\n  </a>\r\n</li>\r\n';
}
return __p;
};
